/* ============================================================
   artvision® · KONTO-MENÜ · Öffnen und Schließen
   Disclosure am Konto-Symbol im Header: Button mit aria-expanded
   und aria-controls, Esc schließt und gibt den Fokus ans Symbol
   zurück, Klick daneben schließt, Fokus außerhalb schließt.
   Ohne dieses Skript bleibt das Symbol ein Link (data-av-account-fallback).
   Läuft auch ohne Collector Login; was die Einträge tun, steuert
   assets/av-auth-layer.js, wenn der Login eingerichtet ist.
   Im Theme-Editor bekommt ein neu gerenderter Header (shopify:section:load)
   wieder ein funktionierendes Menü; ein Menü wird nie doppelt gebunden.
   Gilt für sections/header.liquid (aktiver Header) und
   sections/av-global-header.liquid — beide nutzen dieselben data-Haken.
   Im Dawn-Drawer (snippets/header-drawer.liquid) schließen „Anmelden“,
   „Registrieren“ und „Abmelden“ den Drawer, bevor der Dialog aufgeht bzw.
   der Button verschwindet; der Fokus geht zurück an den Menü-Button.
   ============================================================ */

(function () {
  'use strict';

  var menus = [];
  var drawerEntries = [];
  var isDocumentBound = false;

  function isOpen(menu) {
    return !menu.panel.hidden;
  }

  function open(menu) {
    menu.panel.hidden = false;
    menu.trigger.setAttribute('aria-expanded', 'true');
  }

  function close(menu, shouldRestoreFocus) {
    if (!isOpen(menu)) return;
    menu.panel.hidden = true;
    menu.trigger.setAttribute('aria-expanded', 'false');
    if (shouldRestoreFocus) menu.trigger.focus();
  }

  function onDocumentKeydown(event) {
    if (event.key !== 'Escape') return;
    menus.forEach(function (menu) {
      if (isOpen(menu)) close(menu, true);
    });
  }

  function onDocumentClick(event) {
    menus.forEach(function (menu) {
      if (isOpen(menu) && !menu.root.contains(event.target)) close(menu, false);
    });
  }

  /** One keydown and one click listener on the document serve all menus. */
  function bindDocument() {
    if (isDocumentBound) return;
    isDocumentBound = true;
    document.addEventListener('keydown', onDocumentKeydown);
    document.addEventListener('click', onDocumentClick);
  }

  function isBound(root) {
    return menus.some(function (menu) {
      return menu.root === root;
    });
  }

  function init(root) {
    if (isBound(root)) return;

    var menu = {
      root: root,
      trigger: root.querySelector('[data-av-account-trigger]'),
      panel: root.querySelector('[data-av-account-panel]')
    };
    var fallback = root.querySelector('[data-av-account-fallback]');
    if (!menu.trigger || !menu.panel) {
      console.error('Account menu markup incomplete (sections/av-global-header.liquid).');
      return;
    }

    menus.push(menu);
    bindDocument();

    menu.trigger.addEventListener('click', function () {
      if (isOpen(menu)) {
        close(menu, false);
      } else {
        open(menu);
      }
    });

    // Tab out of the menu (forwards past the last entry or backwards past the icon) closes it.
    root.addEventListener('focusout', function (event) {
      if (isOpen(menu) && event.relatedTarget && !root.contains(event.relatedTarget)) close(menu, false);
    });

    // An entry was chosen: close first, so a layer that opens next returns focus to the icon.
    menu.panel.addEventListener('click', function (event) {
      if (event.target.closest('a, button')) close(menu, true);
    });

    if (fallback) fallback.hidden = true;
    menu.trigger.hidden = false;
  }

  /** Closes Dawn's <header-drawer> through its own API, so it resets focus trap and scroll lock. */
  function closeHeaderDrawer(entries, event) {
    var drawer = entries.closest('header-drawer');
    var summary = drawer && drawer.querySelector('summary');
    if (summary && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event, summary);
  }

  function bindDrawerEntries(entries) {
    if (drawerEntries.indexOf(entries) !== -1) return;
    drawerEntries.push(entries);

    entries.addEventListener('click', function (event) {
      if (event.target.closest('[data-av-auth]') || event.target.closest('[data-av-account-sign-out]')) {
        closeHeaderDrawer(entries, event);
      }
    });
  }

  /**
   * Forgets menus of removed sections, then binds the page's account menu if it
   * is new. One menu per page (the header); a second header block keeps its
   * plain no-JS link. Drawer entries are bound as well.
   */
  function boot() {
    menus = menus.filter(function (menu) {
      return menu.root.isConnected;
    });
    drawerEntries = drawerEntries.filter(function (entries) {
      return entries.isConnected;
    });
    var root = document.querySelector('[data-av-account-menu]');
    if (root) init(root);
    Array.prototype.forEach.call(document.querySelectorAll('[data-av-account-entries="drawer"]'), bindDrawerEntries);
  }

  boot();
  document.addEventListener('shopify:section:load', boot);
})();
